import { Box, Typography, styled } from "@mui/material";

/** Phone chrome + RCS/MMS preview — spacing/shape from theme; mockup colors are fixed (RCS reference). */
export const MockupContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(4),
  borderRadius: theme.spacing(9),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  position: "relative",
  width: "340px",
  height: "704px",
  maxWidth: "100%",
  boxShadow: "none",
}));

export const Screen = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.spacing(8),
  width: "316px",
  maxWidth: "100%",
  height: "680px",
  overflow: "hidden",
  position: "relative",
}));

export const DynamicIsland = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.black,
  width: "112px",
  height: "32px",
  borderRadius: theme.shape.borderRadiusButtonCorner,
  position: "absolute",
  top: theme.spacing(7),
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 10,
}));

export const ScreenHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  height: "65px",
  width: "100%",
  borderBottomWidth: "1px",
  borderBottomStyle: "solid",
  borderBottomColor: theme.palette.tokens.outlines.defaultBordersLight,
}));

export const ContentArea = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: `${theme.spacing(7)} ${theme.spacing(5)}`,
  gap: theme.spacing(4),
  overflowY: "auto",
  height: "calc(100% - 65px)",
  width: "100%",
}));

export const Timestamp = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
  fontFamily: theme.typography.fontFamily,
}));

export const MessageTypeLabel = styled(Typography)(({ theme }) => ({
  fontSize: "11px",
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.disabled,
  textAlign: "center",
  width: "100%",
  marginBottom: theme.spacing(3),
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  fontFamily: theme.typography.fontFamily,
}));

export const MessageBubble = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background["paper-elevation-1"],
  padding: `${theme.spacing(4)} ${theme.spacing(5)}`,
  borderRadius: `${theme.shape.borderRadiusLg}px`,
  alignSelf: "flex-start",
  maxWidth: "242px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  position: "relative",
}));

export const SenderText = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 400,
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
}));

export const MessageText = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: theme.palette.text.primary,
  lineHeight: "20px",
  whiteSpace: "pre-wrap",
  overflowWrap: "anywhere",
  fontFamily: theme.typography.fontFamily,
  "& .preview-url": {
    textDecoration: "underline",
    color: theme.palette.primary.main,
    cursor: "pointer",
  },
}));

export const MediaBlock = styled(Box)(({ theme }) => ({
  width: "100%",
  borderRadius: theme.spacing(4),
  overflow: "hidden",
  marginBottom: theme.spacing(2),
  "& img": {
    width: "100%",
    height: "auto",
    display: "block",
  },
}));

export const RcsCtaContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(5),
  paddingTop: theme.spacing(3),
  borderTopWidth: "1px",
  borderTopStyle: "solid",
  borderTopColor: theme.palette.tokens.outlines.defaultDividerLight,
  width: "100%",
  display: "flex",
  justifyContent: "center",
}));

export const RcsCtaText = styled(Typography)(({ theme }) => ({
  color: theme.palette.info.main,
  fontSize: "14px",
  fontWeight: 600,
  fontFamily: theme.typography.fontFamily,
  cursor: "default",
}));

export const RcsSuggestionRow = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(2),
}));

export const RcsSuggestionPill = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(1),
  color: "#2563eb",
  fontSize: "12px",
  fontWeight: 600,
  fontFamily: theme.typography.fontFamily,
  cursor: "default",
  padding: theme.spacing(1, 3),
  borderRadius: "999px",
  backgroundColor: "#ffffff",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "#e5e7eb",
  whiteSpace: "nowrap",
  "& svg": { fontSize: 14 },
}));
